<template>
    <li
        v-on:mouseover="$emit('mouseover')"
        v-on:mouseleave="$emit('mouseleave')"
        v-if="imovel!=null"
    >
        <div>
            <a :href="url" class="wrap-link" target="_blank">
                <figure class="image is-3by2" :style="`background-image: url(${imagem_url});`">
                    <img src="static/images/480x320.png" alt>
                    <span>{{ tipo }}</span>

                    <ul class="labels">
                        <li
                            v-for="flag in flags"
                            :key="flag.id"
                            :style="{'background-color': flag.cor}"
                        >{{ flag.titulo }}</li>
                    </ul>
                    <ul class="selos">
                       
                        <li v-for="selo in selos" :key="selo.id">
                            <img :src="`_files/${selo.imagem}`" />
                        </li>
                    </ul>
                </figure>
                <div style="min-height:68px;">
                    <p
                        class="location"
                        v-if="empreendimento != ''"
                        style="margin-bottom: auto;"
                    >{{ empreendimento }}</p>
                    <p>{{ bairro }}</p>
                    <p class="location">
                        <img src="static/images/pin.png" alt>
                        {{ cidade }}
                    </p>                    
                    <p v-if="tem_placa">
                        Placa: {{ tem_placa == 'Sim' ? 'Sim': 'Não' }}
                    </p>
                    <p v-if="observacoes && observacoes!=''">
                        Obs: {{ observacoes }}
                    </p>
                    
                </div>
                <p class="price" v-if="valor != 0.0">R${{ valor | number_format(2,',','.') }}</p>
                <ul class="small-block-grid-1 medium-block-grid-2 infos">
                    <li>
                        <img src="static/images/bed.png" alt>
                        {{ dormitorios }} Dorm.
                    </li>
                    <li>
                        <img src="static/images/car.png" alt>
                        {{ vagas }} Vaga{{ vagas != 1 ? 's': '' }}
                    </li>
                </ul>
            </a>
        </div>
    </li>
</template>
<script>
import { rest } from "@/config";
import ImoveisStore from "@/store/imoveis";

export default {
    props: ["placa", "finalidade", "tem_placa", "observacoes"],
    filters: {
        number_format(value, decimals, sep1, sep2) {
            return value.number_format(decimals, sep1, sep2);
        }
    },
    data() {
        return {
            imovel: null,
            imagem_url: ""
        };
    },
    computed: {
        selos() {
            let selos = ImoveisStore.state.selos;
            
            selos = selos.filter(selo => {
                    
                return selo.filtros.reduce((acc, filtro) => {
                    if (acc) {
                        return true;
                    }
                    
                    if (filtro.codigos.length != 0) {
                        let codigos = filtro.codigos.map(codigo => codigo.toLowerCase());
                        if (codigos.includes(this.imovel.placa.toLowerCase())) {
                            return true;
                        }
                    } else {
                        if (this.finalidade != filtro.operacao.slugify()) {
                            return false;
                        }
                        if (this.modalidade != filtro.finalidade.slugify()) {
                            return false;
                        }
                        if (filtro.tipo != '' && filtro.tipo != this.tipo_slug) {
                            return false;
                        }
                        if (filtro.bairro != '' && filtro.bairro != `${this.imovel.bairro} ${this.imovel.cidade} ${this.imovel.uf}`.slugify()) {
                            return false;
                        }
                        if (filtro.cidade != '' && filtro.cidade != `${this.imovel.cidade} ${this.imovel.uf}`.slugify()) {
                            
                            return false;
                        }
                        return true;
                    }

                    return acc;
                }, false);
            });
            return selos;
        },
        flags() {
            let flags = ImoveisStore.state.flags || [];
            if (0 == flags.length) {
                return [];
            }
            if (!this.imovel) {
                return [];
            }

            return [...new Set(this.imovel.flags)]
                .map(flag_id => flags.find(flag => flag.id == flag_id))
                .filter(flag => flag);
        },
        empreendimento() {
            if (!this.imovel) {
                return "";
            }
            return this.imovel.empreendimento || "";
        },
        url() {
            if (!this.imovel) {
                return "";
            }
            let finalidade = this.finalidade;
            let modalidade = this.modalidade;
            let placa = this.placa;
            let tipo = this.tipo;
            let cidade = this.cidade;
            let bairro = this.bairro;
            let uf = this.uf;
            let titulo = [tipo, bairro, cidade, uf].join(" ").slugify();
            //return `imovel/${finalidade}/${placa}/${titulo}`;

            finalidade = finalidade == 'aluguel' ? 'alugar' : 'comprar';
            return `${finalidade}/${modalidade}/${titulo}/${placa}`;
            /*
            let url = '';
            if (this.finalidade == 'aluguel') {
                let [origem, subcodigo] = this.placa.toLowerCase().replace(/([a-zA-Z])([0-9])/igm,'$1-$2').split('-');
                url = `imoveis/${this.finalidade}/${this.cidade.slugify()}/${this.bairro.slugify()}/${this.tipo.slugify()}/${subcodigo}/${origem}`;
            } else {
                url = `imoveis/${this.finalidade}/${this.cidade.slugify()}/${this.bairro.slugify()}/${this.tipo.slugify()}/${this.placa}`;
            }
            return url;
            */
        },
        uf() {
            if (!this.imovel) {
                return "";
            }
            return this.imovel.uf;
        },
        bairro() {
            if (!this.imovel) {
                return "";
            }
            return this.imovel.bairro || "";
        },
        cidade() {
            if (!this.imovel) {
                return "";
            }
            return this.imovel.cidade || "";
        },
        valor() {
            if (!this.imovel) {
                return 0;
            }
            return this.imovel.valor || 0.0;
        },
        dormitorios() {
            if (!this.imovel) {
                return 0;
            }
            return this.imovel.dormitorios | 0;
        },
        vagas() {
            if (!this.imovel) {
                return 0;
            }
            return this.imovel.vagas | 0;
        },
        area() {
            if (!this.imovel) {
                return 0;
            }
            return this.imovel.area | 0;
        },
        imagem_aluguel() {
            if (!this.imovel) {
                return "";
            }
            let imagens = this.imovel.imagens || [];
            if (0 == imagens.length) {
                return "";
            }
            imagens.sort((a, b) => {
                if (a.principal == b.principal) {
                    return a.sequencia < b.sequencia ? -1 : 1;
                }
                return a.principal ? -1 : 1;
            });
            let [{ sequencia }] = imagens;

            let [origem, subcodigo] = this.placa
                .replace(/([a-z])([0-9])/gim, "$1-$2")
                .split("-");

            origem = origem.toLowerCase();
            let codigo = subcodigo.padStart(5, "0");
            if (sequencia != 0) {
                codigo = codigo + "." + sequencia;
            }
            if (origem == "saoluiz") {
                return `${
                    rest.imagens
                }/files/aluguel/${origem}/slui${codigo}.jpg`;
            }
            return `${
                rest.imagens
            }/files/aluguel/${origem}/${origem}${codigo}.jpg`;
        },
        imagem_venda() {
            if (!this.imovel) {
                return "";
            }
            let imagens = this.imovel.imagens;
            if (0 == imagens.length) {
                return "";
            }
            let [imagem] = imagens;
            let url = imagem.url.replace("Site_vilarica", "media");
            if (
                /saoluiz\.imb\.br/.test(location.host) ||
                /sao-lui[sz]/.test(location.pathname)
            ) {
                url = url.replace("vilarica.com.br", "saoluiz.imb.br");
            } else {
                url = url.replace("saoluiz.imb.br", "vilarica.com.br");
            }

            if (
                /(saoluiz\.imb\.br|vilarica\.com\.br)/gim.test(location.host) &&
                /(sao\.img\.br|vilarica\.com\.br)/gim.test(url)
            ) {
                url = url.replace(/^http[s]?/gim, "https");
            }

            //return '';
            return url;
        },
        imagem() {
            let imagem;

            if (this.finalidade == "aluguel") {
                imagem =
                    this.imagem_aluguel ||
                    "http://www.vilarica.com.br/vila_rica/upload/imoveis/sem_imagem.jpg";
            } else {
                imagem =
                    this.imagem_venda ||
                    "http://www.vilarica.com.br/vila_rica/upload/imoveis/sem_imagem.jpg";
            }
            return imagem;
        },
        modalidade() {
            if (!this.imovel) {
                return '';
            }
            let tipo_id = this.imovel.tipo_id;
            let finalidade = this.finalidade;
            
            if (finalidade == 'venda') {                
                //if ([282,222].includes(tipo_id)) {
                if (this.imovel.is_lancamento || this.imovel.is_empreendimento) {
                    return 'lancamento';
                }
                return 'pronto';
            }
            if ([8,9,10,17,19,20,24,25,30,35,38,40,41,48, 49,53, 55].includes(tipo_id)) {
                return 'comercial';
            }
            return 'residencial';

        },
        tipo() {
            if (!this.imovel) {
                return "";
            }
            let tipo_id = this.imovel.tipo_id ;
            let tipos = ImoveisStore.state.tipos[this.finalidade] || [];
            let tipo = tipos.find(({ id }) => id == tipo_id);
            if (!tipo) {
                return "";
            }
            return tipo.titulo || "";
        },
        tipo_slug() {
            if (!this.imovel) {
                return "";
            }
            let tipo_id = this.imovel.tipo_id ;
            let tipos = ImoveisStore.state.tipos[this.finalidade] || [];
            let tipo = tipos.find(({ id }) => id == tipo_id);
            if (!tipo) {
                return "";
            }
            return tipo.slug || "";
        }
    },
    methods: {
        async loadImovel() {
            let finalidade = this.finalidade;
            return fetch(
                `${rest.endpoint}/${finalidade}/imovel/${this.placa}.json?t=${Date.now()}`
            )
                .then(resp => resp.json())
                .then(imovel => {
                    this.imovel = imovel;
                    let img = new Image();
                    img.onload = () => {
                        this.imagem_url = this.imagem;
                    };
                    img.onerror = () => {
                        this.imagem_url =
                            "http://www.vilarica.com.br/vila_rica/upload/imoveis/sem_imagem.jpg";
                    };
                    img.src = this.imagem;
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },
    async created() {
        this.loadImovel();
    }
};
</script>
<style lang="less" scoped>
    ul.selos {
        position: absolute;
        bottom: 1em;
        right: 0;
        list-style: none;
        width: 50%;
        li {
            width: 100%;
            height: 75px;
            img {
                object-fit: contain;
                object-position: right;
                visibility: visible;
                box-shadow: 0 0 10px -2px black;
                max-height: 100%;
                height: auto;
            }
        }
    }
</style>